import Pc from '@/pages/sitemap/influencers'
import Mobile from '@/mobile-pages/sitemap/influencers'
import useIsMobile from '@/hooks/useIsMobile'

const Influencers = (props: any) => {
  return useIsMobile() ? <Mobile {...props} /> : <Pc {...props}></Pc>
}

export { getServerSideProps } from '@/mobile-pages/sitemap/influencers/index'

export default Influencers
